export const Disprz_Skills_Table_1_1 = [
    {
      colKey: "checkbox",
      colValue: "checkbox",
      width: 60,
    },
    {
      colType: "skillId",
      colKey: "skillName",
      colValue: "Skill Name",
      disableToolTip: true,
      width: 300
    },
    {
      colKey: "skillCategory",
      colValue: "Skill Category",
      width: 300
    },
    {
      colKey: "skillDescription",
      colValue: "Skill Description",
      width: 300
    },
    {
      colType: "levelSelect",
      colKey: "selectLevel",
      colValue: "Set Industry Proficiency 4PL",
      editable: true,
      width: 260,
    },{
      colType: "levelSelect",
      colKey: "selectLevel",
      colValue: "Set Industry Proficiency 5PL",
      editable: true,
      width: 260,
    },{
      colType: "levelSelect",
      colKey: "selectLevel",
      colValue: "Set Industry Proficiency 6PL",
      editable: true,
      width: 260,
    }
  ];

export const GetDisprzSkillsTableV2 = ({
  listOfSchemeId = [], // e.g., [4, 5, 6]
} = {}) => {
  const baseColumns = [
    {
      colKey: "checkbox",
      colValue: "checkbox",
      width: 60,
    },
    {
      colType: "skillId",
      colKey: "skillName",
      colValue: "Skill Name",
      disableToolTip: true,
      width: 300,
    },
    {
      colKey: "skillCategory",
      colValue: "Skill Category",
      width: 300,
    },
    {
      colKey: "skillDescription",
      colValue: "Skill Description",
      width: 300,
    },
  ];

  const dynamicLevelColumns = listOfSchemeId.map((count) => ({
    colKey: `target_proficiency${count}`,
    colValue: `Industry Proficiency ${count}PL`,
    editable: true,
    colType: "levelSelect",
    width: 260,
    proficiencySchemeLevelCount: count
  }));

  return [...baseColumns, ...dynamicLevelColumns];
};


export const Disprz_Skills_Table = [
    {
      colKey: "checkbox",
      colValue: "checkbox",
      width: 60,
    },
    {
      colType: "skillId",
      colKey: "skillName",
      colValue: "Skill Name",
      disableToolTip: true,
      width: 300
    },
    {
      colKey: "skillCategory",
      colValue: "Skill Category",
      width: 300
    },
    {
      colKey: "skillDescription",
      colValue: "Skill Description",
      width: 300
    },
    {
      colType: "levelSelect",
      colKey: "selectLevel",
      colValue: "Industry Proficiency",
      editable: true,
      width: 260,
    }
  ];

export const Non_Disprz_Skills_Table = [
    {
      colKey: "skillName",
      colValue: "Skill Name",
      width: 300
    },
    {
      colKey: "skillDescription",
      colValue: "Skill Description",
      width: 300
    }
  ];
